module.exports = __webpack_public_path__ + "img/part.a0422664.svg";